import React from 'react';
import ProjectSummaryTable from './ProjectSummaryTable';
import { fmtInrNoSymbol } from './reportUtils';

/** Single portfolio overview table from project master rows. */
const PortfolioSnapshotTable = ({ projectMaster = [] }) => {
  const columns = [
    { key: 'projectName', label: 'Project' },
    { key: 'clientName', label: 'Client' },
    {
      key: 'agreementValue',
      label: 'Agreement value (₹)',
      align: 'right',
      render: (v) => (v != null ? fmtInrNoSymbol(v) : '—'),
    },
    { key: 'currentStage', label: 'Status' },
    { key: 'projectManager', label: 'Project manager' },
  ];

  return (
    <section id="sm-portfolio" className="sm-portfolio">
      <div className="sm-portfolio__head">
        <h2 className="sm-portfolio__title">Portfolio snapshot</h2>
        <div className="sm-badge-strip">
          <span className="sm-badge sm-badge--navy">{projectMaster.length} project(s) in scope</span>
        </div>
      </div>
      <ProjectSummaryTable
        columns={columns}
        rows={projectMaster}
        meta="Projects in scope for this report"
        emptyText="No project master rows for the selected filters."
      />
    </section>
  );
};

export default PortfolioSnapshotTable;
